<div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <div [hidden]="!hasRouteAccess(routes.SECURE.QR.PAYMENTS)" class="form-group">
        <div [hidden]="isResultListEmpty()" class="margin-top-bottom">
          <h3>
            <i class="fa fa-info-circle"></i> No payments found. </h3>
          </div>
          <app-search-view>
            <app-qr-search #app
              [accountType]="AccountType.QR_PAYMENT"
              [autoRefresh]="true"
            filters></app-qr-search>
            <table class="table table-hover table-responsive-md table-wrap-sm" grid>
              <div class="sort-field-md">
                <p-select (onChange)="applySorting(selectedSortField?.id, app)"
                  [(ngModel)]="selectedSortField"
                  [options]="sortFields"
                  [showClear]="true"
                  class="sort-field"
                  optionLabel="name"
                placeholder=" Sort by:"></p-select>
                <em (click)="applySorting(selectedSortField?.id,app)"
                class="{{ isDesc(selectedSortField?.id) ? 'fa fa-sort-desc': isAsc(selectedSortField?.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
              </div>
              <thead>
                <tr>
                  <th #dateTimeCreated
                    (click)="applySorting(dateTimeCreated.id, app)"
                    class="sort-field"
                    id="dateTimeCreated"
                    scope="col">Date Created
                    <em class="{{ isDesc(dateTimeCreated.id) ? 'fa fa-sort-desc': isAsc(dateTimeCreated.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #description
                    (click)="applySorting(description.id, app)"
                    class="sort-field"
                    id="description"
                    scope="col">Description
                    <em class="{{ isDesc(description.id) ? 'fa fa-sort-desc': isAsc(description.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #referenceNumber
                    (click)="applySorting(referenceNumber.id, app)"
                    class="sort-field"
                    id="referenceNumber"
                    scope="col">Reference
                    <em class="{{ isDesc(referenceNumber.id) ? 'fa fa-sort-desc': isAsc(referenceNumber.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #amount
                    (click)="applySorting(amount.id, app)"
                    class="sort-field"
                    id="amountPaid"
                    scope="col">Amount
                    <em class="{{ isDesc(amount.id) ? 'fa fa-sort-desc': isAsc(amount.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th id="status" scope="col">Status <i class="pi pi-question-circle tooltip-icon"
                  pTooltip="{{getAccountStatusUtil().getDescriptionOfAllFormatted()}}"></i>
                </th>
              </tr>
            </thead>
            <tbody class="table-hover text-nowrap">
              @for (qrPayment of contents; track qrPayment) {
                <tr class="cursor-pointer  active-color">
                  <td (click)="view(qrPayment)">
                    <span class="p-column-title">Date Created</span>
                    {{ qrPayment.dateTimeCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}
                  </td>
                  <td (click)="view(qrPayment)">
                    <span class="p-column-title">Description</span>
                    {{ qrPayment.description }}
                  </td>
                  <td (click)="view(qrPayment)">
                    <span class="p-column-title">Reference</span>
                    {{ qrPayment.referenceNumber }}
                  </td>
                  <td (click)="view(qrPayment)">
                    <span class="p-column-title">Amount</span>
                    {{
                    getAmount(qrPayment) | toMajor |
                    currency:'R '
                    }}
                  </td>
                  <td (click)="view(qrPayment)" class="account_status_col">
                    <span class="p-column-title">Status</span>
                    <span [ngClass]="getAccountStatusUtil().getAccountTextColorClass(qrPayment.accountState)">
                      {{ qrPayment.accountState | getAccountStatusDescription }}
                    </span>
                  </td>
                  <hr/>
                </tr>
              }
            </tbody>
          </table>
        </app-search-view>
      </div>
    </div>
  </div>
</div>